import axios from 'axios'
import ActionsLogin from './LoginActions'

const config = {
  headers: {
    Authorization: 'Bearer ' + ActionsLogin.getToken()
  }
}

const listarAceiteTermoPorMotorista = async (codigoMotorista) => {
  let response = await axios.get(
    process.env.URL_API_BASE +
      '/motorista-aceite-termo/listar-por-motorista/' +
      codigoMotorista,
    config
  )
  return response.data
}

const obterAceiteTermo = async (id) => {
  let response = await axios.get(
    process.env.URL_API_BASE + '/motorista-aceite-termo/' + id,
    config
  )
  return response.data
}

export default {
  listarAceiteTermoPorMotorista,
  obterAceiteTermo
}



// WEBPACK FOOTER //
// ./src/actions/MotoristaAceiteTermoActions.js